import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1bce2122"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "footer fsb"
};
var _hoisted_2 = {
  "class": "flex-start"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "content-text"
  }, "OpenName © 2024", -1);
});
var _hoisted_4 = {
  "class": "content-text"
};
var _hoisted_5 = {
  "class": "flex-start"
};
var _hoisted_6 = {
  "class": "cooperation"
};
var _hoisted_7 = {
  "class": "icon"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = ["src"];
var _hoisted_10 = ["src"];
var _hoisted_11 = ["src"];
var _hoisted_12 = ["src"];
var _hoisted_13 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$toUrl('/docs?docsName=PrivacyPolicy');
    })
  }, _toDisplayString(_ctx.$t('footer.privacy_policy')), 1), _createTextVNode(" | "), _createElementVNode("span", {
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$toUrl('/docs?docsName=TermsOfUse');
    })
  }, _toDisplayString(_ctx.$t('footer.user_agreement')), 1)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    src: require('@/assets/image/footer/icon_foot1.svg'),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.$toUrl('https://twitter.com/OpenNameProject');
    })
  }, null, 8, _hoisted_8), _createElementVNode("img", {
    src: require('@/assets/image/footer/icon_telegram.svg'),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.$toUrl('https://t.me/opennameproject');
    })
  }, null, 8, _hoisted_9), _createElementVNode("img", {
    src: require('@/assets/image/footer/icon_foot5.svg'),
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return _ctx.$toUrl('https://medium.com/@openname');
    })
  }, null, 8, _hoisted_10), _createElementVNode("img", {
    src: require('@/assets/image/footer/icon_foot2.svg'),
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return _ctx.$toUrl('https://discord.com/invite/G83NXk7YHp');
    })
  }, null, 8, _hoisted_11), _createElementVNode("img", {
    src: require('@/assets/image/footer/icon_foot4.svg'),
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return _ctx.$toUrl('https://docs.open.name');
    })
  }, null, 8, _hoisted_12), _createElementVNode("img", {
    src: require('@/assets/image/footer/icon_opensea.svg'),
    onClick: _cache[7] || (_cache[7] = function ($event) {
      return _ctx.$toUrl('https://opensea.io/OpenNameProject/created');
    })
  }, null, 8, _hoisted_13)])])])]);
}